<template>
  <Modal v-model="visible" title="新增开票" :footer-hide="true" :mask-closable="false" class="my-modal top" width="800px" @on-cancel="cancel">
    <Form ref="formValidate" :label-width="100" :model="searchParams">
      <FormItem label="发票类型" prop="billType">
        <Select v-model="searchParams.billType" clearable>
          <Option value="1">普票</Option>
          <Option value="2">专票</Option>
        </Select>
      </FormItem>
      <FormItem label="发票代码" prop="billCode">
        <Input v-model="searchParams.billCode" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="发票号" prop="billNum" :rules="$units.formRule.required('请输入发票号')">
        <Input v-model="searchParams.billNum" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="发票金额" prop="billAmount" :rules="$units.formRule.required('请输入发票金额')">
        <Input v-model="searchParams.billAmount" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="开票人" prop="billDrawer">
        <Input v-model="searchParams.billDrawer" placeholder="请输入" clearable />
      </FormItem>
      <FormItem label="开票日期" prop="billDate" :rules="$units.formRule.objRequired('请选择开票日期')">
        <DatePicker transfer v-model="searchParams.billDate" format="yyyy-MM-dd" type="date" placeholder="请选择">
        </DatePicker>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="cancel">取消</Button>
      <Button type="primary" @click="submit">确定</Button>
    </div>
  </Modal>
</template>

<script>
import uploadNew from "@/components/commons/uploadNew";
export default {
  components: { uploadNew },
  data() {
    return {
      visible: false,
      imgUrl: "",
      searchParams: {},
    }
  },
  methods: {
    cancel(){
      this.visible = false
      this.searchParams={}
    },
    submit() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          let url = ''
          if (this.searchParams.id) {
            url = '/buz/molCommissionCheckBill/edit'
          } else {
            url = '/buz/molCommissionCheckBill/add'
          }
          this.$http({
            url: url,
            type: 'POST',
            data: {
              ...this.searchParams,
              checkId: this.$route.query.id
            },
          }).then(() => {
            this.visible = false
            this.$emit('refresh')
          })
        }
      });
    },
    open(item) {
      this.searchParams={}
      if (item) {
        this.getData(item)
      }
      this.visible = true
      this.clearMessage()
    },
    getData(item) {
      this.$http({
        url: '/buz/molCommissionCheckBill/read/detail',
        type: 'GET',
        data: {
          id: item.id
        },
      }).then((res) => {
        this.searchParams = res.data
      })
    },
    clearMessage() {
      // 基础信息
      this.$refs.formValidate.fields.forEach(item => {
        item.validateState = '';
        item.validateMessage = '';
      });
    },
  }

}
</script>

<style lang="scss" scoped>
/deep/ .ivu-date-picker {
  width: 100%;
}

/deep/ .ivu-modal-body {
  padding-top: 20px !important;
}

/deep/ .ivu-form {
  display: flex;
  flex: 1;
  flex-wrap: wrap;
}

/deep/ .ivu-form-item {
  width: 50%;
}
</style>